
import ViewBox from 'vux/src/components/view-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {mixins} from "../../assets/js/utils";
import Scroller from '../common/scroll/Scroller.vue';
import {DEVICE_RATIO,DOWN_CONFIG,UP_CONFIG} from '../common/scroll/base/js/config.js';

export default {
directives: {
TransferDom
},
components: {
ViewBox,
GroupTitle,
Group,
Cell, CellBox, Flexbox, FlexboxItem, XDialog, Scroller
},
created (){
this.initPage();
},
mixins: [mixins],
methods: {
pullUpHandle(){
this.getInfo((res)=>{
this.scrollElement.PullingUpWord="加载完成";
setTimeout(()=>{
this.scrollElement.finish("PullUp");
if(res.data.data.rows.length != 0) {
this.dataList=this.dataList.concat(res.data.data.rows);
this.curYear = null;
}
},1000)
})
},
initPage(){
this.dataList=[];
this.page=1;
this.getInfo((res)=>{
this.dataList=res.data.data.rows;
})
},
getInfo(callback){
let shopId = this.shopId;
let promoteAccountId = this.promoteAccountId;
let withdrawalNo = this.withdrawalNo;
let uri = this.apiBaseUri+"/GET_COMMISSION_BILL_RECORD_LIST";
let params = {
"shopId":shopId,
"promoteAccountId":promoteAccountId,
"currentPage":this.page,
"pageSize":this.pageSize
};
if(withdrawalNo){
params["withdrawalNo"] = this.withdrawalNo;
}
let _this = this;
_this.axios.post(uri, params, {
headers: {}
}).then(function (response) {
if (response.data.code != undefined && response.data.code == 0) {
_this.billInfo = response.data.data.commissionWithdrawalBill;
callback&&callback(response);
_this.page++;
} else{
_this.showHideOnBlur = true;
_this.dialogMsg = response.data.msg;
}
}).catch(function (response) {
_this.showHideOnBlur = true;
_this.dialogMsg = response.message;
});
},

doConfirm (){
if(this.billInfo.status != 0 || this.billInfo.orderNum == 0){
return;
}
let _this = this;
this.axios.post(this.apiBaseUri+"COMMISSION_WITHDRAWAL_BILL", {
shopId:this.shopId,
promoteAccountId:this.promoteAccountId
}, {
headers: {}
}).then(function (response) {
let data = response.data;
if (data.code == 0 && data.data) {
_this.billInfo.status = 2;
_this.showHideOnBlur = true;
_this.dialogMsg = "结算成功";
}else{
_this.showHideOnBlur = true;
_this.dialogMsg = response.data.msg;
}
}).catch(function (response) {
_this.showHideOnBlur = true;
_this.dialogMsg = response.message;
});
}
},
data () {
let shopId = this.$route.params.shopId;
return {
dialogMsg: '',
showHideOnBlur:false,
dataList:[],
billInfo:{},
shopId,
withdrawalNo: this.$route.params.withdrawalNo,
promoteAccountId: this.$route.params.promoteAccountId,
apiBaseUri: '/v1/shop/'+ shopId+'/bill/',
page:1,
pageSize:15,
pulldown: true,
DEVICE_RATIO,
DOWN_CONFIG,
UP_CONFIG
}
},
computed: {
buttonText (){
switch (this.billInfo.status){
case 0:
return "立即结算";
case 1:
return "未确认";
case 2:
return "已确认";
case 3:
return "发起付款";
case 4:
return "付款成功";
default:
return "加载中...";
}
},
buttonColor(){
switch (this.billInfo.status){
case 0:
if(this.billInfo.orderNum > 0) {
return "#409EFF";
}
default:
return "gray";
}
},
scrollElement(){
return this.$refs.scroll
}
}
}



// WEBPACK FOOTER //
// ./src/components/member/RebateBill.vue